/* tslint:disable:max-line-length */
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const CheckCircleIcon = ({
  className,
  style: styleFromProps,
  color,
  onClick,
  size,
}: IconTypeProps) => {
  const fill = color || colors.green;
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={classNames(className)}
      onClick={onClick}
    >
      <rect opacity="0.4" width="47" height="47" rx="23.5" fill={fill} />
      <rect
        x="6.06451"
        y="5.30646"
        width="35.629"
        height="35.629"
        rx="17.8145"
        fill={fill}
      />
      <path
        d="M21.091 30.6452C20.6911 30.6452 20.2908 30.4984 19.9857 30.2047L14.4579 24.8862C13.8474 24.2987 13.8474 23.3463 14.4579 22.7589C15.0685 22.1714 16.0583 22.1714 16.6689 22.7589L21.091 27.0135L31.0408 17.4405C31.6514 16.8532 32.6414 16.8531 33.2516 17.4405C33.8624 18.028 33.8624 18.9806 33.2516 19.5678L22.1965 30.2047C21.8912 30.4982 21.4911 30.6452 21.091 30.6452Z"
        fill="white"
      />
    </svg>
  );
};
